export const transition = {
  animation: {
    scale: true,
  },
  transition: {
    scale: true,
  },
  transitionDelay: {
    scale: true,
  },
  transitionDuration: {
    scale: true,
  },
  transitionProperty: {
    scale: true,
  },
  transitionTimingFunction: {
    scale: true,
  },
  willChange: {
    scale: true,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Transition = typeof transition;
